import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { bosAtlasStore } from './redux/Store';
import 'leaflet.fullscreen';
import { enableMapSet } from 'immer';
import { App } from './components/App';
import { reportWebVitals } from './reportWebVitals';
import axios from 'axios';
import { errorInterceptor } from './interceptors';

import '@fontsource/roboto';
import './styles/index.scss';

enableMapSet();
axios.interceptors.response.use(function (response) {
	return response;
}, errorInterceptor);

ReactDOM.render(
	<Provider store={bosAtlasStore}>
		<React.StrictMode>
			<App />
		</React.StrictMode>
	</Provider>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
